import React, { useContext } from "react";
import { Route, Routes } from "react-router-dom";
import AboutUs from "./components/core/About";
import Header from "./components/core/Header";
import Home from "./components/Home";
import Register from "./components/userAuth/Register";
import Login from "./components/userAuth/Login";
import Hangman from './Games/Hangman/components/Game'
import MemoryGame from './Games/MemoryGame/components/Game'
import TicTacToe from './Games/TicTacToe/components/Game'
import Minesweeper from "./Games/Minesweeper/components/Game";
import FooterBar from "./components/core/Footer";
import ProtectedRoutes from "./ProtectedRoutes";
import LetterToSantaParent from './components/letterToSanta/letterToSantaParent'
import LetterToSantaChild from './components/letterToSanta/letterToSantaChild'
import ResetPassword from "./components/userAuth/ResetPassword";
import "../../client/src/styles/partials/cane.scss";
import AdventCalender from "./components/advent/AdventCalendar";
import SecretSanta from "./components/secretSanta/SecretSanta";
import ListChildAndGifts from "./components/letterToSanta/ListChildAndGifts";
import GiftList from './components/giftList/GiftList'
import SecretSantaPairs from './components/secretSanta/SecretSantaPairs'
import GetStarted from './components/core/GetStarted';
import AppState from "./context/AppContext";
function MainRouter() {
  const context = useContext(AppState)
  return (
      <div className="allPageContainer">
        <div className="row p-0 m-0 d-flex justify-content-center">
          <div className="col-1 p-0">
            <div className="leftCane"></div>
          </div>
          <div className="col-10 p-0 d-flex flex-column justify-content-between allPageGrid">
            {context.store.parentMode &&   <Header />}
            <div className="d-flex flex-column align-items-center text-center">
              <Routes>
                <Route exact path="/" element={<Home />} />
                <Route exact path="/login" element={<Login />} />
                <Route exact path="/register" element={<Register />} />
                <Route exact path="/about-us" element={<AboutUs />} />
                <Route exact path="/activity-hangman" element={<Hangman />} />
                <Route exact path="/activity-memory" element={<MemoryGame />} />
                <Route exact path="/activity-tic-tac-toe" element={<TicTacToe />} />
                <Route exact path="/activity-minesweeper" element={<Minesweeper />} />
                <Route exact path="/secret-santa-pairs" element={<SecretSantaPairs />} />
                <Route
                    exact
                    path="/reset-password/:resetToken"
                    element={<ResetPassword />}
                />
                <Route exact path="/advent-calendar" element={<AdventCalender />} />
                <Route exact path="/secret-santa" element={<SecretSanta />} />
                <Route element={<ProtectedRoutes/>}>
                  <Route exact path="/letter-to-santa-parent" element={<LetterToSantaParent />}/>
                  <Route exact path="/letter-to-santa-child" element={<LetterToSantaChild />}/>
                  <Route exact path="/letter-to-santa-parent-list" element={<ListChildAndGifts />}/>,
                  <Route exact path="/gift-list" element={<GiftList />} />
                  <Route exact path="/register" element={<GetStarted />} />
                </Route>
              </Routes>
            </div>
            <FooterBar />
          </div>
          <div className="col-1 p-0">
            <div className="rightCane"></div>
          </div>
        </div>
      </div>
  );
}
export default MainRouter;
